import { useDatasourcesStore } from "@/stores/datasources";
import { defineNuxtPlugin } from "nuxt/app";
export default defineNuxtPlugin(async () => {
  const store = useDatasourcesStore();
  if (false) {
    await store.fetchAll();
  }
});